import { useState } from "react";
import { Dialog } from "@mui/material";
import { Container } from "./container";
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { MenuOrderingContainerCameras } from "../menuOrderingCameras/menuOrderingContainerCameras";
import { useContext } from "react";
import { DrawerContext } from "../../context/drawerContext";

export function MenuOrderingContainer({
    showMenuOrdering,
}) {
const {
    handleCloseMenuOrderingContainer,
    idEstado
} = useContext(DrawerContext);
const [showMenuOrderingCameras, setShowMenuOrderingCameras] = useState(false);
const [idRegiao, setIdRegiao] = useState('');

  function handleCloseMenuOrderingCameras() {
    setShowMenuOrderingCameras(false)
  }
    return (
        <Dialog
        onClose={handleCloseMenuOrderingContainer} 
        open={showMenuOrdering}
        >
            <DndProvider backend={HTML5Backend}>
                <Container 
                setShowMenuOrderingCameras={setShowMenuOrderingCameras}
                setIdRegiao={setIdRegiao}
                idEstado={idEstado}
                />
            </DndProvider>
            <MenuOrderingContainerCameras 
            showMenuOrderingCameras={showMenuOrderingCameras}
            handleCloseMenuOrderingCameras={handleCloseMenuOrderingCameras}
            idRegiao={idRegiao}
            />
        </Dialog>
    )
}